import React, { useState, useEffect } from 'react'
import styled from '@emotion/styled'
import { ThemeProvider } from 'emotion-theming'

import 'scss/layout.scss'
import Navbar from 'components/Navbar'
import Footer from 'components/Footer'
import { AuthService, DatabaseService } from 'services'
import { breakpoints, lightTheme, darkTheme } from 'utils/styles'
import { useDarkMode } from 'utils/hooks/useDarkMode'

const ViewPort = styled("div")`
  height: 100%;
  width: 100%;
  margin: 0 auto;
  padding: 0 0;
  text-align: center;
  min-height: 100vh;
  background-image: ${props => (props.nav ? "radial-gradient(#d7d7d7 1px, transparent 1px),radial-gradient(#d7d7d7 1px, transparent 1px)" : `none`)}; 
  background-position: 0 0, 20px 20px;
  background-size: 20px 20px;
  overflow: hidden;
`

const Container = styled.div`
  margin: 0 auto;
  max-width: ${props => (props.nav ? "960px" : `none`)};
  padding: ${props => (props.nav ? `0px 1.0875rem 1.45rem` : 0)};
  padding-top: 0;
  min-height: 60vh;
`

export default function Layout(props) {
  const {
    children,
    displayFooter = true,
    displayNav = true,
    navbarProps = {},
    viewportProps = {},
    isOnboarding,
    login,
    isAuth,
    ...childProps
  } = props

  const [theme, toggleTheme] = useDarkMode()
  const themeMode = theme === 'light' ? lightTheme : darkTheme

  return (
    <ThemeProvider theme={themeMode}>
      <ViewPort {...viewportProps} nav={displayNav}>
        {displayNav && <Navbar location={props.location} isOnboarding={isOnboarding} login={login} {...navbarProps} />}
        <Container nav={displayNav}>
          <main>
            {React.Children.map(children, child =>
              React.cloneElement(child, {
                ...childProps,
                theme,
                toggleTheme,
                isAuth
              })
            )}
          </main>
        </Container>
        <Footer displayFooter={displayFooter} />
      </ViewPort>
    </ThemeProvider>
  )
}



